import { getLoadedSceneDefinition, useSceneStore } from "@/engine/SceneManager";
import { ResourceGauges } from "./ResourceGauges";
import { CalendarStrip } from "./CalendarStrip";
import { PortraitAnchor } from "./PortraitAnchor";
import { DestinyTokenStrip } from "./DestinyTokenStrip";
import { tokens } from "@/art/tokens";
import { useForgePickerStore } from "@/state/forgePicker";
import { useRun } from "@/state/run";
import { ForgePickerOverlay } from "@/components/forge/ForgePickerOverlay";

/**
 * 씬 위 오버레이. 현재 씬의 manifest.hud 설정에 따라 표시할 컴포넌트 결정.
 * 씬 인덱스의 경계 밖에 배치되어 전환 애니메이션에 영향 안 받음.
 */
export function HudLayer() {
    const stack = useSceneStore(s => s.stack);
    const registry = useSceneStore(s => s.registry);
    const forgePickerMode = useForgePickerStore(s => s.mode);
    const closeForgePicker = useForgePickerStore(s => s.close);
    const run = useRun(s => s.run);

    const top = stack[stack.length - 1];
    if (!top) return null;
    const def = getLoadedSceneDefinition(registry[top.id]);
    const hud = def?.manifest.hud;
    if (!hud) return null;
    if (!hud.resourceGauges && !hud.calendar && !hud.portrait) return null;

    return (
        <div
            className="absolute inset-0 pointer-events-none"
            style={{ zIndex: tokens.elevation.hud }}
        >
            {/* 좌상단 자원 + 운명 토큰 스트립 (resourceGauges 옵션에 함께 묶음).
                2026-04-23: BackButton (top=xl=40, padding 8+16, 높이 ~52 → 40~92 점유)
                과 겹치는 문제로 top 88 → 108 로 하향. BackButton 하단과 12~16px gap 확보. */}
            {hud.resourceGauges && (
                <div className="absolute left-l pointer-events-auto flex flex-col gap-s" style={{ top: 108 }}>
                    <ResourceGauges />
                    <DestinyTokenStrip />
                </div>
            )}
            {/* 상단 중앙 달력 */}
            {hud.calendar && (
                <div className="absolute top-l left-1/2 -translate-x-1/2 pointer-events-auto">
                    <CalendarStrip />
                </div>
            )}
            {/* 우하단 캐릭터 초상 */}
            {hud.portrait && (
                <div className="absolute bottom-l right-l pointer-events-auto">
                    <PortraitAnchor />
                </div>
            )}
            {/* 2026-04-25: 글로벌 ForgePickerOverlay — Portrait 메뉴 / WeeklyTurn 툴바 등 어디서나 .open() 가능. */}
            {forgePickerMode && run && (
                <div className="pointer-events-auto">
                    <ForgePickerOverlay
                        runId={run.id}
                        mode={forgePickerMode}
                        onClose={closeForgePicker}
                    />
                </div>
            )}
        </div>
    );
}
